import setCurrentPage from "src/Utils/setCurrentPage";
import setPreviousPage from "src/Utils/setPreviousPage";

const LIST_DATA_BENEFITS_TEMPLATE = [
  {
    icon: "cloudWithScheme",
    iconColor: "white",
    text: "Cloud-native, micro services \narchitecture delivers enhanced \n reliability and allows operators to \nhand-pick modules targeting \n specific automation needs",
    listItemCustomStyle: { width: "400px" },
  },
  {
    icon: "puzzle",
    iconColor: "white",
    text: "Use-case-specific profiles with a \nlimited feature set are well-suited \n for small operators looking for a\n pay-as-you-grow pricing model",
    listItemCustomStyle: { width: "400px" },
  },
  {
    icon: "computerWithPolice",
    iconColor: "white",
    text: "Framework for design and \ndeployment of AI/ML-driven auto-\n healing capabilities targeting \nclosed-loop assurance",
    listItemCustomStyle: { width: "400px" },
  },
];

export const DATA_BENEFITS_TCA_3 = {
  title: "Improve operational agility",
  titleNumber: "3.",
  text: "Unlock unmatched performance with a best-in-class modular \narchitecture, harnessing the power of industry-leading initiatives from\n Linux Foundation, including ONAP and Nephio.",
  listData: LIST_DATA_BENEFITS_TEMPLATE,
  next: {
    label: "Challenges Solved",
    onClick: () => setCurrentPage("ILO_305"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ILO_303"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/TCA/TCA_Intro_04.jpg",
  demoButtons: [
    {
      label: "Network DESIGNER DEMO",
      onClick: () => {
        setPreviousPage("ILO_304");
        setCurrentPage("ILO_306");
      },
      endIcon: "arrow-right",
    },
    {
      label: "Network operation team DEMO",
      onClick: () => {
        setPreviousPage("ILO_304");
        setCurrentPage("ILO_312");
      },
      endIcon: "arrow-right",
    },
  ],
};
